import React from "react";
import ReactDOM from "react-dom";
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import { PortalizedModalContext } from "../contexts/portalizedModalContext";

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex:999
  },
  content: {
    borderRadius: 0,
    position: 'fixed',
    padding: 0,
    top: '50%',
    right: 'unset',
    bottom: 'unset',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 576 ? '500px' : 'calc(100% - 32px)',
    backgroundColor:'rgba(0, 0, 0, 0.0)',
    border:'0',
    zIndex: '2'
  }
}

export default function PortalizedModal() {
  const { modal, closeModal, content } = React.useContext(PortalizedModalContext);
  
  if (!modal) return null;

  return ReactDOM.createPortal(
    <Modal
      portalClassName="fadein-modal"
      ariaHideApp={false}
      isOpen={true}
      onRequestClose={closeModal}
      style={modalStyles}
      closeTimeoutMS={500}
    >
      <div className="bg-white p-3">
        {
          content.title &&
            <div className="border-bottom-0 pb-0 mb-2 m-r-10">
              <h5 className="modal-title title weight-700 fs-19">{content.title}</h5>
            </div>
        }
        <span
          style={{position: 'absolute', height: '30px',top: '15px', right: '16px', width:'20px', cursor: 'pointer' }}
          onClick={closeModal} 
        >
          <MdClose color="#000" size="25px" />
        </span>
        {content.content}
      </div>
    </Modal>,
    document.querySelector("#portalized-modal-root")
  );
}
